import { useMatter } from "../../contexts/MatterContext";
import NoMatterView from "../../components/NoMatterView";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import { Heading } from "../../design/heading";
import { HolidayScheduleUpsellCard } from "./components/HolidayScheduleUpsellCard";
import { useHolidaySchedule } from "../../contexts/HolidayScheduleContext";
import HolidayScheduleButton from "../../components/HolidayScheduleButton";
import HolidayRulesViewer from "./components/HolidayRulesViewer";
import EmptyStateView from "../../components/EmptyStateView";
import { useNavigate } from "react-router-dom";
import { Link } from "../../design/link";
import { Button } from "../../design/button";
import DraftHolidayScheduleListItem from "./components/DraftHolidayScheduleListItem";

const HolidaySchedulePage = () => {
  const { currentMatter } = useMatter();
  const { currentHolidaySchedule, holidaySchedules, loading, error } =
    useHolidaySchedule();
  const navigate = useNavigate();

  if (loading.list) return <LoadingView title="Loading Holiday Schedule" />;
  if (error.list) return <ErrorView error={error.list} />;

  const hasHolidayFeature = currentMatter?.unlockedFeatures?.includes(
    "holiday_schedule_tracker",
  );
  const draftHolidaySchedules = holidaySchedules.filter(
    (schedule) => schedule.status === "draft",
  );

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Heading>Holiday Schedule</Heading>
        <div className="flex items-center gap-2">
          {hasHolidayFeature && <HolidayScheduleButton />}
          {hasHolidayFeature && currentHolidaySchedule && (
            <Button
              onClick={() =>
                navigate(`/holiday-schedule/${currentHolidaySchedule._id}`)
              }
            >
              Edit Current Schedule
            </Button>
          )}
        </div>
      </div>

      {!hasHolidayFeature && <HolidayScheduleUpsellCard />}
      {hasHolidayFeature && (
        <>
          {draftHolidaySchedules.map((schedule) => (
            <DraftHolidayScheduleListItem
              key={schedule._id}
              holidaySchedule={schedule}
            />
          ))}
          {hasHolidayFeature && currentHolidaySchedule ? (
            <>
              <HolidayRulesViewer holidaySchedule={currentHolidaySchedule} />
              <div className="flex items-center justify-center gap-4">
                <Link
                  href={`/holiday-schedules`}
                  className="text-sm font-medium text-blue-600 hover:underline"
                >
                  View Other Schedules
                </Link>
              </div>
            </>
          ) : (
            <EmptyStateView
              title="No Holiday Schedule Found"
              message="It seems like there are no holiday schedules available for this matter."
              action={
                <HolidayScheduleButton
                  onSave={(id) => navigate(`/holiday-schedule/${id}`)}
                />
              }
            />
          )}
        </>
      )}
    </div>
  );
};

export default HolidaySchedulePage;
